import React from 'react';
import Project from './Project';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'project';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <Project
        key={`${type}-${index}`}
        project={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
